<template>
    <svg class="border-decoration" width="125" height="15" version="1.1" viewBox="0 0 125 15" xmlns="http://www.w3.org/2000/svg">
        <rect y="7.5" width="125" height="7.5" :style="'fill:' + primary"/>
        <rect x="37.501" width="50.001" height="7.5" :style="'fill:' + secondary"/>
    </svg>
</template>

<script>
export default {
    name: "BorderDecoration",
    props: {
        primary: {
            type: String,
            default: 'var(--color-primary)'
        },
        secondary: {
            type: String,
            default: 'var(--color-secondary)'
        }
    }
}
</script>

<style scoped>

</style>
